export const SELECTION_ELEMENT = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.SelectionElement';
